module.exports = __webpack_public_path__ + "static/media/checkbig.89ac898a.svg";